/**
 * Checks if the current environment is Vitest.
 * Vitest is a unit testing framework.
 */
export const isVitest = (): boolean =>
  typeof process !== 'undefined' && !!process.env?.VITEST;
